'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;

import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FREE, PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { IsMobileContext, isMon569WidthMobile } from '../product-pages/mobileUtils';
import HighlightedFreeCard from '../product-pages/HighlightedFreeCard';
import HighlightedMerchCard from '../product-pages/HighlightedMerchCard';
import AllPlansIncludeFooter from '../product-pages/AllPlansIncludeFooter';
import { TAB_IDS } from '../../constants/Mon569SidenavConfig';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import debounce from '../../utils/wtDebounce';
import Mon569MobileProductLevelSelector from './Mon569MobileProductLevelSelector';
import { borderStyle } from '../common/MerchCardSharedComponents';
import { CMS } from 'self-service-api/constants/ProductLines';
import { useSelector } from 'react-redux';
import { paidProductLevelsForProductLineSelector } from '../../selectors/ProductsSelectors';
const GridContainer = styled.div.withConfig({
  displayName: "Mon569HubTierInfo__GridContainer",
  componentId: "tb07e6-0"
})(["display:flex;flex-direction:column;", ""], breakpoint.cs(_t || (_t = _`
    align-items: center;
  `)));
/* stylelint-disable property-no-vendor-prefix */

const StyledGrid = styled.div.withConfig({
  displayName: "Mon569HubTierInfo__StyledGrid",
  componentId: "tb07e6-1"
})(["display:-ms-grid;display:grid;box-shadow:none !important;grid-template-columns:repeat( ", ",calc(100% / ", ") );-ms-grid-columns:(calc(100% / ", ")) [ ", "];border:", ";max-width:", "px;width:100%;", " ", " ", ";"], props => props.columns, props => props.columns, props => props.columns, props => props.columns, borderStyle, props => props.columns * 600, breakpoint.cs(_t2 || (_t2 = _`
    margin-top: 20px;
  `)), breakpoint.tablet(_t3 || (_t3 = _`
    display: flex;
    flex-direction: column;
    max-width: 600px;
    min-width: auto;
    &:first-child {
      border-bottom: ${0}
    }
  `), borderStyle), breakpoint.phone(_t4 || (_t4 = _`
    max-width: initial;
    width: 90% !important;
  `)));

const Mon569HubTierInfo = ({
  productLine,
  selectedTab
}) => {
  const [isMobile, setIsMobile] = useState(isMon569WidthMobile(window.innerWidth));
  useEffect(() => {
    const resizeWindow = debounce(() => {
      setIsMobile(isMon569WidthMobile(window.innerWidth));
    }, 250);
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);
  const paidProductLevels = useSelector(reduxState => {
    return paidProductLevelsForProductLineSelector(reduxState, {
      productLine
    });
  });

  const getAllEligibleProductLevels = () => {
    switch (productLine) {
      case CMS:
        return paidProductLevels;

      default:
        return [FREE, ...paidProductLevels];
    }
  };

  const allEligibleProductLevels = getAllEligibleProductLevels();
  const productLevelsToShow = selectedTab === TAB_IDS.starter ? allEligibleProductLevels.slice(0, allEligibleProductLevels.indexOf(PROFESSIONAL)) : allEligibleProductLevels.slice(allEligibleProductLevels.indexOf(PROFESSIONAL));
  const merchCardComponents = productLevelsToShow.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 32,
      paddingRight: 32,
      borderRight: index < productLevelsToShow.length - 1 ? borderStyle : 'none'
    };
    return productLevel === FREE ? /*#__PURE__*/_jsx(HighlightedFreeCard, {
      productLine: productLine,
      commonStyles: commonStyles
    }, productLevel) : /*#__PURE__*/_jsx(HighlightedMerchCard, {
      productLevel: productLevel,
      productLine: productLine,
      commonStyles: commonStyles,
      productLevelsToShow: productLevelsToShow
    }, productLevel);
  });
  return /*#__PURE__*/_jsx(IsMobileContext.Provider, {
    value: isMobile,
    children: /*#__PURE__*/_jsxs(GridContainer, {
      children: [isMobile && /*#__PURE__*/_jsx(Mon569MobileProductLevelSelector, {
        productLine: productLine
      }), /*#__PURE__*/_jsxs(StyledGrid, {
        columns: productLevelsToShow.length,
        children: [merchCardComponents, /*#__PURE__*/_jsx(AllPlansIncludeFooter, {
          productLevels: productLevelsToShow,
          borderStyle: borderStyle
        })]
      })]
    })
  });
};

export default Mon569HubTierInfo;